import { render } from "./plus.svg?vue&type=template&id=097b8850"
const script = {}
script.render = render

export default script